import axios from "axios";
import { API_HEADERS, GET_SKU } from "../../constants";

export const getSKU = async (skuData) => {
  try {
    const result = await axios.post(
      `${GET_SKU}/product-dimensions`,
      { ...skuData },
      {
        headers: API_HEADERS,
      }
    );

    return result.data;
  } catch (error) {
    // Handle error appropriately (e.g., logging, error messages)
    console.error("Error fetching SKU", error);
    throw error; // Re-throw the error to be handled by the caller
  }
};
